var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1.793a1 1 0 0 1 1.414 0l2.793 2.79a1 1 0 0 1 0 1.415l-7.853 7.856A.5.5 0 0 1 6 14H3a1 1 0 0 1-1-1v-2.793a1 1 0 0 1 .293-.707zm3.5 3.498L10.707 2.5 3 10.207V13h2.793z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 13.5A.5.5 0 0 1 6 13h7.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5M8.146 3.646a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;